import { portfolio } from "../data/portfolio";
import { SectionHead } from "../components/SectionHead";

export function About() {
  const P = portfolio;
  return (
    <section id="about" className="md-section">
      <div className="md-container">
        <SectionHead
          num="01"
          eyebrow="About"
          title="From Hello-World to agentic systems."
          dek="The short version of how a “does this compile?” kid ended up shipping multi-agent LLM systems."
        />

        <div className="m3-about__grid reveal">
          <div className="md-card md-card--outlined md-card__pad m3-about__prose">
            {P.about.map((p, i) => (
              <p key={i} className="md-body-l">
                {p}
              </p>
            ))}
          </div>

          <div className="md-card md-card--filled md-card__pad m3-now">
            <div className="m3-now__head">
              <span className="m3-now__dot" />
              <span className="md-title-m">Now</span>
            </div>
            {P.now.map((n, i) => (
              <div key={i} className="m3-now__item">
                <span className="material-symbols-rounded">arrow_forward</span>
                <span className="md-body-m">{n}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="m3-journey reveal">
          <div className="m3-journey__head">
            <div className="md-label-l accent">Journey</div>
            <h3 className="md-headline-s" style={{ margin: "4px 0 0" }}>
              Hello-World → research career.
            </h3>
          </div>
          <div className="md-card md-card--outlined m3-journey__card">
            <ol className="m3-journey__list">
              {P.journey.map((j, i) => (
                <li key={i} className="m3-journey__item">
                  <div className="m3-journey__year md-label-l">{j.year}</div>
                  <div className="m3-journey__rail" aria-hidden="true">
                    <span className="m3-journey__dot" />
                    {i < P.journey.length - 1 && <span className="m3-journey__line" />}
                  </div>
                  <div className="m3-journey__body">
                    <div className="md-title-m">{j.title}</div>
                    <div className="md-body-s dim" style={{ marginTop: 2 }}>
                      {j.note}
                    </div>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>

        <div className="m3-about__bottom reveal">
          <div className="md-card md-card--tonal-pri md-card__pad">
            <div className="md-label-l" style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              <span className="material-symbols-rounded icon-20 icon-filled">favorite</span>
              Tech I love
            </div>
            <p className="md-body-m" style={{ marginTop: 8, marginBottom: 16, opacity: 0.85 }}>
              The tools I reach for first — half utility, half aesthetic.
            </p>
            <div className="md-chip-group">
              {P.loves.map((t) => (
                <span key={t.name} className="md-chip md-chip--elevated">
                  <span className="material-symbols-rounded icon-20">{t.icon}</span>
                  {t.name}
                </span>
              ))}
            </div>
          </div>

          <div className="m3-outside">
            <div
              className="md-label-l accent"
              style={{ marginBottom: 12, display: "inline-flex", alignItems: "center", gap: 8 }}
            >
              <span className="material-symbols-rounded icon-20">coffee</span>
              Outside the code
            </div>
            <div className="m3-outside__grid">
              {P.outside.map((o) => (
                <div key={o.label} className="md-card md-card--outlined m3-outside__card">
                  <span className="m3-outside__icon">
                    <span className="material-symbols-rounded icon-20">{o.icon}</span>
                  </span>
                  <div>
                    <div className="md-title-s">{o.label}</div>
                    <div className="md-body-s dim" style={{ marginTop: 2 }}>
                      {o.value}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
